import {
  requestPendingList,
  requestShippedList,
  requestUndecidedList,
  requestDownloadedList,
  requestMarketList,
} from '@/api/pending';

const state = {
  pendingList: null,
  shippedList: null,
  undecidedList: null,
  downloadedList: null,
  marketList: null,
};

const getters = {
  pendingList: (state) => state.pendingList,
  shippedList: (state) => state.shippedList,
  undecidedList: (state) => state.undecidedList,
  downloadedList: (state) => state.downloadedList,
  marketList: (state) => state.marketList,
};

const actions = {
  async setPendingList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPendingList({ pageNumber });
    commit('setPendingList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setShippedList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestShippedList({ pageNumber });
    commit('setShippedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setUndecidedList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestUndecidedList({ pageNumber });
    commit('setUndecidedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setDownloadedList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestDownloadedList({ pageNumber });
    commit('setDownloadedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setMarketList({ commit, dispatch, rootGetters }, { pageNumber, postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const page = pageNumber;
    const result = await requestMarketList({ csrfToken, page, postParams }); // APIどれを呼び出すか
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setMarketList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setPendingList(state, pendingList) {
    state.pendingList = pendingList;
  },
  setShippedList(state, shippedList) {
    state.shippedList = shippedList;
  },
  setUndecidedList(state, undecidedList) {
    state.undecidedList = undecidedList;
  },
  setDownloadedList(state, downloadedList) {
    state.downloadedList = downloadedList;
  },
  setMarketList(state, marketList) {
    state.marketList = marketList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
